/** Normalize coach from API string or object. */
export function normalizeCoach(coach) {
  if (!coach) return null;
  if (typeof coach === 'string') {
    return {
      name: coach,
      nationality: '',
      age: '',
      role: 'Head coach',
      since: '',
    };
  }
  return {
    name: coach.name || '',
    nationality: coach.nationality || coach.country || '',
    age: coach.age != null && coach.age !== '' ? String(coach.age) : '',
    role: coach.role || 'Head coach',
    since: coach.since || coach.appointed || '',
  };
}

export function coachDisplayName(coach) {
  return normalizeCoach(coach)?.name || '';
}

export function coachInitials(name) {
  if (!name) return '?';
  return name
    .split(/\s+/)
    .filter(Boolean)
    .map((w) => w[0])
    .join('')
    .slice(0, 2)
    .toUpperCase();
}
